import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';
import type { ExpansionGroupingsResponse } from './types';

const validate = (runId: number, subscriptionId: number) => {
  if (!runId || runId < 1) {
    throw new Error('Valid run ID is required');
  }
  if (!subscriptionId || subscriptionId < 1) {
    throw new Error('Valid subscription ID is required');
  }
};

type RequestParams = {
  runId: number;
  /** Any subscription of the organization — see `getRunFamilies`. */
  subscriptionId: number;
};

/** The destination categories the run placed products in, largest first. */
export const getRunGroupings = async (
  scope: RequestScope,
  { runId, subscriptionId }: RequestParams,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<ExpansionGroupingsResponse>> => {
  try {
    validate(runId, subscriptionId);

    const result = await scopedChannelApi(scope).get<ExpansionGroupingsResponse>(`atts/expansion/runs/${runId}/groupings`, {
      ...options,
      headers: { 'x-astur-subscription-id': subscriptionId.toString() },
    });

    return { data: result.data, status: result.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
